<template>
	<div class="px-5">
		<app-table
			class="mt-5 is-not-selectable"
			name="apps"
			:columns="columns"
			:current-page="currentPage"
			:rows="rows"
			:last-page="lastPage"
			@on-search-event="onSearch"
			@on-page="changePage"
		>
			<template slot="rows" slot-scope="props">
				<td
					class="is-not-selectable"
					v-show="showRow(columns, 1)"
				>
					{{ props.row.id }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.name }}
				</td>
				<td v-show="showRow(columns, 3)">
					{{ props.row.codeApp }}
				</td>
				<td v-show="showRow(columns, 4)">
					{{ props.row.repo }}
				</td>
				<td>
					<app-tooltip-button
						color="green"
						icon="edit"
						text="Editar App"
						@click-icon="edit(props.row)"
					/>
					<app-tooltip-button
						color="blue"
						icon="link"
						text="Módulos"
						@click-icon="openModules(props.row)"
					/>
					<app-tooltip-button
						color="red"
						icon="delete"
						text="Eliminar App"
						@click-icon="openModalConfirmation(props.row)"
					/>
					<app-tooltip-button
						color="purple"
						icon="menu"
						text="Ver sidebar"
						@click-icon="goToSidebar(props.row)"
					/>
				</td>
			</template>
		</app-table>
		<app-confirmation-modal
			:loading="loading"
			:show-modal="modalConfirmation.value"
			@cancel="cancelModalConfirmation"
			@confirm="confirm()"
		/>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';
import appConfirmationModal from '@/components/shared/app-confirmation-modal';

function changePage(page) {
	this.$emit('change-page', page);
}

function confirm() {
	this.loading = true;
	this.$http
		.delete(`app/${this.modalConfirmation.selectedRow.id}`)
		.then(() => {
			this.showNotification('Registro eliminado correctamente');
			this.modalConfirmation.value = false;
			this.$emit('on-delete');
		})
		.finally(() => {
			this.loading = false;
		});
}

function edit({ id }) {
	this.goTo('page-app-edit', { params: { id } });
}

function goToSidebar({ codeApp }) {
	this.goTo('page-sidebar', { params: { codeApp } });
}

function openModules({ codeApp }) {
	this.goTo('page-module', { params: { codeApp } });
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function data() {
	return {
		loading: false,
	};
}

export default {
	name: 'apps-list',
	components: {
		appConfirmationModal,
		appTooltipButton,
	},
	data,
	methods: {
		changePage,
		confirm,
		edit,
		goToSidebar,
		onSearch,
		openModules,
	},
	props: {
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/apps/app-list.vue